// extracted by mini-css-extract-plugin
export default {"delConfirmText":"delConfirmText___NV3ei"};